import styled from "styled-components";
import media from "styled-media-query";
import customMedia from "../../config/breakpoints";

export const StyledUrgencyCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey100};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 32px;
  box-sizing: border-box;
  gap: 24px;
  min-height: 160px;

  ${customMedia.lessThan("mobile")`
    min-height: 190px;
 `}
`;

export const PhoneContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const DesktopLink = styled.div`
  ${customMedia.lessThan("mobile")`
    display:none;
`}
`;

export const MobileLink = styled.div`
  ${customMedia.greaterThan("mobile")`
    display:none;
`}
`;

export const TextContainer = styled.div`
  flex: 1;
`;
